module.exports = __webpack_public_path__ + "img/bg-cover-cusco.jpg";